import { getValue } from "@utils/lodash";
import "./notificationbar.scss";
import Dropdown from "../common/Dropdown";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

export default function NavigationBar(props: any) {
  return (
    <div className="navigation-bar-wrapper">
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <p className="navigation-bar-wrapper__selected">
            {getValue(props, `selectedIDs.length`, 0)} Selected
          </p>
          {props.isFilterVisisbile && (
            <>
              <Dropdown />
              <div className="filter-checklist d-flex align-items-center">
                <img src="/images/filter-white.svg" className="img-fluid" />
                <p className="navigation-bar-wrapper__selected cursor-pointer">
                  {/* FILTER SIMILAR CHECKLIST */}
                  Filter Similar Checklist
                </p>
              </div>
            </>
          )}

          <UncontrolledDropdown>
            <DropdownToggle caret>
              {getValue(props, `name`, "")
                ? getValue(props, `name`, "")
                : "Take Action"}
              <img src="/images/arrow-drop-white.svg" className="img-fluid" />
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem header>
                <div className="d-flex align-items-center justify-content-between">
                  <h6 className="dropdown-header-title">
                    <b>Update Status</b>
                  </h6>
                </div>
              </DropdownItem>


              {props.isMarkInactiveSectionVisible && !props.multi && (
                <DropdownItem onClick={props.handleChangeActiveStatus}>
                  {getValue(props, `text`, "")
                    ? getValue(props, `text`, "")
                    : "Mark Inactive"}
                </DropdownItem>
              )}

              {
                props.multi && (
                  <>
                    <DropdownItem onClick={() => props.handleChangeActiveStatus("active")}>
                      <span>Mark Active</span>
                    </DropdownItem>

                    <DropdownItem onClick={() => props.handleChangeActiveStatus("inactive")}>
                      <span>Mark Inactive</span>
                    </DropdownItem>
                  </>
                )
              }

          {props.mfa_multi && (
            <>
              <DropdownItem onClick={() => props.handleChangeMFAStatus("active")}>
                <span>MFA Active</span>
              </DropdownItem>

              <DropdownItem onClick={() => props.handleChangeMFAStatus("inactive")}>
                <span>MFA Inactive</span>
              </DropdownItem>
            </>
          )}

          {getValue(props, `entityMapping`, false) &&
            getValue(props, `selectedIDs.length`, 0) === 1 && (
              <DropdownItem onClick={() => props.handleNavigateUserEntity("inactive")}>
              <span>Entity Mapping</span>
            </DropdownItem>
          )}

          {getValue(props, `locationMapping`, false) &&
            getValue(props, `selectedIDs.length`, 0) === 1 && (
              <DropdownItem onClick={() => props.handleNavigateLocation()}>
                <span>Location Mapping</span>
              </DropdownItem>
          )}

          {getValue(props, `internalMapping`, false) &&
            getValue(props, `selectedIDs.length`, 0) === 1 && (
              <DropdownItem onClick={() =>
                props.handleNavigateUserInternalEntity("inactive")
              }>
              <span>Internal Mapping</span>
            </DropdownItem>
            )}

          {props.confure &&
            getValue(props, `permissions`, []).includes("update") && (
              <>
                <DropdownItem onClick={() => props.confureModal()}>
                  <span>configure</span>
                </DropdownItem>
              </>
            )}
          {props.delete && (
            <>
              <DropdownItem onClick={() => props.handleDeleteFun()}>
                  <span>Delete</span>
                </DropdownItem>
            </>
          )}
            </DropdownMenu>
          </UncontrolledDropdown>

          {props.isUpdateTaskVisible && (
            <>
              <div
                className="position-relative"
                onClick={() => {
                  props.showUpdatePopup(true);
                }}
              >
                <div className="filter-checklist d-flex align-items-center mx-3">
                  {/* <p className="filter-checklist-text cursor-pointer medium-bold-font">
                    Update Task
                  </p> */}
                  <p className="filter-checklist-text cursor-pointer medium-bold-font">
                    {getValue(props, `selectedIDs.length`, 0) > 1 ? "Bulk" : ""}{" "}
                    Update Task
                  </p>
                  <img
                    src="/images/edit-white.svg"
                    className="img-fluid edit-image"
                  />
                </div>
              </div>
            </>
          )}

          <div className="d-none">
            {props.isMarkInactiveSectionVisible && !props.multi && (
              <div
                className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                onClick={props.handleChangeActiveStatus}
              >
                <img src="/images/assignment.svg" className="img-fluid" />
                <h6>
                  {getValue(props, `text`, "")
                    ? getValue(props, `text`, "")
                    : "Mark Inactive"}
                </h6>
              </div>
            )}
            {
              props.multi && (
                // getValue(props, `permissions`, []).includes("update") && (
                <>
                  <div
                    className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                    onClick={() => props.handleChangeActiveStatus("active")}
                  >
                    <img src="/images/assignment.svg" className="img-fluid" />
                    <h6>Mark Active</h6>
                  </div>
                  <div
                    className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                    onClick={() => props.handleChangeActiveStatus("inactive")}
                  >
                    <img src="/images/assignment.svg" className="img-fluid" />
                    <h6>Mark Inactive</h6>
                  </div>
                </>
              )
              // )
            }
            {props.mfa_multi && (
              <>
                <div
                  className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                  onClick={() => props.handleChangeMFAStatus("active")}
                >
                  <img src="/images/assignment.svg" className="img-fluid" />
                  <h6>MFA Active</h6>
                </div>
                <div
                  className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                  onClick={() => props.handleChangeMFAStatus("inactive")}
                >
                  <img src="/images/assignment.svg" className="img-fluid" />
                  <h6>MFA Inactive</h6>
                </div>
              </>
            )}
            {getValue(props, `entityMapping`, false) &&
              getValue(props, `selectedIDs.length`, 0) === 1 && (
                <div
                  className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                  onClick={() => props.handleNavigateUserEntity("inactive")}
                >
                  <img src="/images/assignment.svg" className="img-fluid" />
                  <h6>
                    {/* ENTITY MAPPING */}
                    Entity Mapping
                  </h6>
                </div>
              )}

            {getValue(props, `locationMapping`, false) &&
              getValue(props, `selectedIDs.length`, 0) === 1 && (
                <div
                  className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                  onClick={() => props.handleNavigateLocation()}
                >
                  <img src="/images/assignment.svg" className="img-fluid" />
                  <h6>Location Mapping</h6>
                </div>
              )}

            {getValue(props, `internalMapping`, false) &&
              getValue(props, `selectedIDs.length`, 0) === 1 && (
                <div
                  className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                  onClick={() =>
                    props.handleNavigateUserInternalEntity("inactive")
                  }
                >
                  <img src="/images/assignment.svg" className="img-fluid" />
                  <h6>
                    {/* INTERNAL MAPPING */}
                    Internal Mapping
                  </h6>
                </div>
              )}

            {props.confure &&
              getValue(props, `permissions`, []).includes("update") && (
                <>
                  <div
                    className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                    onClick={() => props.confureModal()}
                  >
                    <img src="/images/assignment.svg" className="img-fluid" />
                    <h6>
                      {/* CONFIGURE */}
                      configure
                    </h6>
                  </div>
                </>
              )}
            {props.delete && (
              <>
                <div
                  className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                  onClick={() => props.handleDeleteFun()}
                >
                  <img src="/images/assignment.svg" className="img-fluid" />
                  <h6>Delete</h6>
                </div>
              </>
            )}
          </div>
          
        </div>
        <img
          src="/images/close-white.svg"
          className="img-fluid navigation-bar-wrapper__close-btn"
          onClick={props.handleRemoveNavItems}
        />
      </div>
    </div>
  );
}
